import axios from 'axios'
import { api } from '@/global'
import { authHeader } from '@/services/auth-header'

function save(data){
    return axios.post( `${api.private}roles`, data, {
        headers: authHeader()
    })
}

function read(){
    return axios.get( `${api.private}roles`, {
        headers: authHeader()
    })
}

function destroy(id){
    return axios.delete( `${api.private}roles/${id}`, {
        headers: authHeader()
    })
}

export {
    save,
    read,
    destroy
}